import { useState } from "react";
import styled from "styled-components";
import theme from "../theme/theme";
import logo from "../assets/logo.png";
import GarwoodHelpPopup from "./GarwoodHelpPopup/GarwoodHelpPopup";

const Wrapper = styled.header`
  background-color: ${theme.colors.white};
  padding: 1em 1em;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;

  nav {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .navBarOptionsHolder {
      display: flex;
      gap: 10px;
      @media (max-width: 480px) {
        gap: 0;
        align-items: center;
      }
    }
  }

  .logo {
    cursor: pointer;
    width: 200px;
    @media (max-width: 480px) {
      width: 150px;
      margin-right: 10px;
    }
  }
`;

const HelpLink = styled.a`
  border-bottom: ${(props) =>
    `${
      props.isUnderlineVisible
        ? `3px solid ${theme.colors.primary}`
        : "3px solid white"
    }`};
  padding: 5px;
  letter-spacing: 0px;
  line-height: 1.25;
  text-decoration: none;
  color: ${theme.colors.primaryStrong2X};
  height: fit-content;
  font-weight: 700;
  cursor: pointer;
  te &:hover {
    color: ${theme.colors.primary};
  }

  .userName {
    color: ${theme.colors.primary};
  }
`;

const HeaderWithLogo = ({ isHelpButtonVisible = true }) => {
  const [isHelpPopupVisible, setIsHelpPopupVisible] = useState(false);
  return (
    <Wrapper>
      <nav>
        <a href="https://tactivewealth.com/" target="blank">
          <img className="logo" src={logo} alt="logo" />
        </a>
      </nav>
      <>
        {isHelpPopupVisible && (
          <GarwoodHelpPopup setIsHelpPopupVisible={setIsHelpPopupVisible} />
        )}
        {isHelpButtonVisible && (
          <HelpLink
            isUnderlineVisible={isHelpPopupVisible}
            onClick={() => {
              setIsHelpPopupVisible(true);
            }}
          >
            Help
          </HelpLink>
        )}
      </>
    </Wrapper>
  );
};

export default HeaderWithLogo;
